<oui-dialog-content class="dialog-content">
  <div class="dialog-body">
    <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
      <oui-icon>close</oui-icon>
    </oui-button>
    <oui-icon class="icon-size">publish</oui-icon>

    <div class="subtitle-1">
      Vous êtes sur le point de rendre public un document: {{ data.docType }},
      souhaitez-vous continuer ?
    </div>
  </div>
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button (click)="confirm()">Oui</oui-button>
  <oui-button type="text" oui-dialog-close>Non</oui-button>
</oui-dialog-actions>
